// ---------------------------------------------------------------------------
// De onde vem a alteracao da triagem que o store esta a fazer agora.
//
// A triagem partilhada envia o que muda na triagem local. Ha mudancas que
// sao do utilizador (um estado, uma nota, apagar um parecer) e mudancas
// que NAO sao decisoes de ninguem:
//
//   - substituicao: ler o que estava guardado (hidratar), repor uma
//     sessao, desfazer uma reconciliacao retida, limpar ("Fechar sessao").
//     A triagem inteira troca de uma vez; o que desaparece nao foi
//     apagado por ninguem.
//   - reconciliacao: gravar o resultado de uma corrida. Muda estados
//     (resolvido, reaberto) e nunca apaga; uma entrada que muda de chave
//     (outra revisao) continua a ser a mesma.
//
// Nestes dois casos o que desaparece nao se apaga na partilhada. Sem
// isto, abrir uma sessao antiga apagava no servidor os pareceres dos
// colegas que a sessao nao tinha.
//
// Os listeners do zustand correm dentro do `set`, por isso basta marcar
// a volta do `set` (ver clashSlice.ts).
// ---------------------------------------------------------------------------

export type OrigemDaAlteracao = 'edicao' | 'substituicao' | 'reconciliacao'

let origem: OrigemDaAlteracao = 'edicao'

/** Corre `fn` (que faz o `set`) com a origem indicada. */
export function comOrigem<T>(o: OrigemDaAlteracao, fn: () => T): T {
  const antes = origem
  origem = o
  try {
    return fn()
  } finally {
    origem = antes
  }
}

/** A origem da alteracao em curso. */
export function origemDaAlteracao(): OrigemDaAlteracao {
  return origem
}
